import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators'
import store from '@/store'
import Product from "@/model/Product";
import {Container} from "typescript-ioc";
import ProductApi from "@/module/device/ProductApi";
import ProductStorage from "@/storage/ProductStorage";
import ActiveModule from "@/store/module/ActiveModule";

export abstract class ProductModule implements ActiveModule<Product> {
    abstract active: Product

    abstract activeOrNull: Product | null

    abstract activate(product: Product): Promise<void>

    abstract inactivate(): Promise<void>

    abstract hasActive(): Promise<boolean>

    abstract destroy(): Promise<void>
}

@Module({dynamic: true, store, namespaced: true, name: 'product'})
class ProductModuleImpl extends VuexModule implements ProductModule {

    private productApi = Container.get(ProductApi)

    private productStorage = Container.get(ProductStorage)

    activeOrNull = this.productStorage.getOrNull()

    get active() {
        return this.activeOrNull ?? new Product()
    }

    @Action
    async hasActiveProduct(): Promise<boolean> {
        return this.activeOrNull != null
    }

    @Action
    async activate(product: Product) {
        this.set(product)
        this.productStorage.set(product)
    }

    @Action
    async inactivate() {
        this.remove()
        this.productStorage.remove()
    }

    @Action
    async hasActive(): Promise<boolean> {
        return this.activeOrNull != null
    }

    @Action
    async destroy() {
        this.inactivate()
    }

    @Mutation
    private set(product: Product) {
        this.activeOrNull = product
    }

    @Mutation
    private remove() {
        this.activeOrNull = null
    }
}

const productModule: ProductModule = getModule(ProductModuleImpl)
export default productModule
